import { render, staticRenderFns } from "./V2ProfileAddress.vue?vue&type=template&id=a43ebc26&scoped=true&"
import script from "./V2ProfileAddress.vue?vue&type=script&lang=js&"
export * from "./V2ProfileAddress.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileAddress.vue?vue&type=style&index=0&id=a43ebc26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43ebc26",
  null
  
)

export default component.exports